/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELResource,
  OTELResource$Outbound,
  OTELResource$outboundSchema,
} from "./otelresource.js";
import {
  OTELScopeMetrics,
  OTELScopeMetrics$Outbound,
  OTELScopeMetrics$outboundSchema,
} from "./otelscopemetrics.js";

/**
 * OTEL resource metrics container
 */
export type OTELResourceMetrics = {
  /**
   * OTEL resource information
   */
  resource?: OTELResource | undefined;
  /**
   * Array of scope metrics
   */
  scopeMetrics?: Array<OTELScopeMetrics> | undefined;
};

/** @internal */
export type OTELResourceMetrics$Outbound = {
  resource?: OTELResource$Outbound | undefined;
  scopeMetrics?: Array<OTELScopeMetrics$Outbound> | undefined;
};

/** @internal */
export const OTELResourceMetrics$outboundSchema: z.ZodMiniType<
  OTELResourceMetrics$Outbound,
  OTELResourceMetrics
> = z.object({
  resource: z.optional(OTELResource$outboundSchema),
  scopeMetrics: z.optional(z.array(OTELScopeMetrics$outboundSchema)),
});

export function otelResourceMetricsToJSON(
  otelResourceMetrics: OTELResourceMetrics,
): string {
  return JSON.stringify(
    OTELResourceMetrics$outboundSchema.parse(otelResourceMetrics),
  );
}
